import { render, staticRenderFns } from "./presentation-details-section.vue?vue&type=template&id=0eb1ec38&"
import script from "./presentation-details-section.vue?vue&type=script&lang=js&"
export * from "./presentation-details-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports